import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] max-h-[900px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20majestic%20aerial%20view%20of%20the%20Kunlun%20Mountain%20range%20with%20snow-capped%20peaks%20and%20ancient%20glaciers%20shimmering%20under%20crystal%20clear%20sunlight%2C%20pristine%20white%20snow%20and%20ice%20formations%2C%20deep%20valleys%20with%20turquoise%20glacial%20lakes%2C%20ethereal%20atmosphere%20with%20soft%20mist%2C%20cinematic%20landscape%20photography%20style%2C%20clean%20minimal%20composition%2C%20natural%20grandeur&width=1800&height=900&seq=hero-kunlun-2026&orientation=landscape"
        alt="昆仑山万年冰川雪峰全景"
        title="昆仑雪 - 源自昆仑山万年冰川的纯净力量"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-4xl">
          <p className="text-background-50/80 text-sm md:text-base tracking-[0.3em] font-heading mb-4 animate-[fadeIn_1s_ease-out]">
            源自世界屋脊的天然馈赠
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 mb-6 leading-tight animate-[fadeIn_1s_ease-out_0.2s]">
            昆仑雪
          </h1>
          <p className="text-lg md:text-2xl text-background-50/90 font-light tracking-wide mb-10 animate-[fadeIn_1s_ease-out_0.4s]">
            源自雪山的纯净力量
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeIn_1s_ease-out_0.6s]">
            <Link
              to="/categories"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              探索产品系列
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              了解品牌故事
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}